import { createSelector } from 'reselect'
import T from 'i18n-react'

import {
  listOrder,
} from './constants'
import {
  entitySelector,
} from 'containers/Entity/selectors'

const listEntitySelector = (state) => {
  const lists = entitySelector(state).lists
  return lists ? Object.values(lists) : []
}

const skusEntitySelector = (state) => {
  const skus = entitySelector(state).skus
  return skus ? Object.values(skus) : []
} 

const listSelector = createSelector(
  listEntitySelector,
  (lists) => {
    let rows = lists
    if (lists.length > 0) {
      const sortedColumnHeaders = Object.keys(rows[0])
        .filter(columnKey => listOrder[columnKey] !== undefined)
        .sort((columnA, columnB) => listOrder[columnA] - listOrder[columnB])
      const columnHeaders = sortedColumnHeaders.map(header => T.translate(`product.list.table.${header}`))
      rows = rows.map(rowValue => (sortedColumnHeaders.map(columnKey => rowValue[columnKey])))
      rows = [columnHeaders, ...rows]
    }
    return rows
  }
)

const productSkusSelector = createSelector(
  skusEntitySelector,
  (skus) => skus.map(skuObj => skuObj.sku)
) 

const inputValueSelector = state => state.uiState.productSearch.inputValue || ''
const activeAddDialogSelector = state => state.uiState.productSearch.activeAddDialog || false
const creatingProductSelector = state => state.uiState.productSearch.creatingProduct || false
const productSkuSourcesSelector = state => state.uiState.productSearch.productSkuSources || []
const segmentSourcesSelector = state => state.uiState.productSearch.segmentSources || []
const lineSourcesSelector = state => state.uiState.productSearch.lineSources || []
const loadingSkuListSelector = state => state.uiState.productSearch.loadingSkuList || false

export {
  listSelector,
  inputValueSelector,
  activeAddDialogSelector,
  creatingProductSelector,
  productSkusSelector,
  productSkuSourcesSelector,
  segmentSourcesSelector,
  lineSourcesSelector,
  loadingSkuListSelector,
}